import { Component, Vue, Prop as prop, Watch as watch} from 'nuxt-property-decorator';

@Component({
    components: {
        checkboxField: require('~/components/form/checkbox-field/').default,
    }
})
export default class SelectableListComponent extends Vue {

    @prop()
    public value: string[];

    @prop()
    public set: any;

    @watch('value')
    public function() {
        this.$emit('input', this.value);
    }

    public toggle(val: string) {

        const index = this.value.indexOf(val);

        if (index !== -1) {
            this.value.splice(index, 1);
        } else {
            this.value.push(val);
        }

        this.$emit('input', this.value);
    }
}
